import { BasicsClass } from '@/common/BasicsClass';

export class BallRoomAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getBallRoomTableList', {
            url: '/admin/shop/lists',
            name: 'list',
            label: '球房列表'
        }],
        ['add', {
            url: '/admin/shop/add',
            name: 'add',
            label: '球房新增',
            // hidden: true
        }],

        ['edit', {
            url: '/admin/shop/update',
            name: 'edit',
            label: '球房编辑',
        }],
        // ['delete', {
        //     url: '/admin/user/roomDel',
        //     name: 'delete',
        //     label: '球房删除',
        // }],
        ['getProvince', {
            url: '/admin/shop/province',
            name: 'province-list',
            label: '省份列表（下拉选择）'
        }],
        ['getCity', {
            url: '/admin/shop/city',
            name: 'city-list',
            label: '地级市列表（下拉选择）'
        }],
    ])

    public getBallRoomTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getBallRoomTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    public addBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('add').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public editBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('edit').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public removeBallRoom(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('delete').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public getProvince(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getProvince').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public getCity(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('getCity').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

}